// src/directive/watermark.js
import Vue from 'vue'

function addWatermark(el, binding) {
    const text = binding.value || '未登录用户'
    const options = binding.modifiers || {}

    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    // 配置参数
    const fontSize = options.fontSize || 16
    const color = options.color || 'rgba(0, 0, 0, 0.08)'
    const rotate = options.rotate || -25
    const gapX = options.gapX || 200
    const gapY = options.gapY || 150

    // 设置画布大小
    canvas.width = gapX
    canvas.height = gapY

    // 绘制水印文字
    ctx.font = `${fontSize}px "Microsoft YaHei", "PingFang SC", "Helvetica Neue", Arial, sans-serif`
    ctx.fillStyle = color
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'

    // 旋转画布
    ctx.translate(canvas.width / 2, canvas.height / 2)
    ctx.rotate((rotate * Math.PI) / 180)
    ctx.fillText(text, 0, 0)

    // 将canvas转换为背景图
    const watermarkUrl = canvas.toDataURL('image/png')

    // 设置水印样式
    const watermarkDiv = document.createElement('div')
    watermarkDiv.style.position = 'absolute'
    watermarkDiv.style.top = '0'
    watermarkDiv.style.left = '0'
    watermarkDiv.style.width = '100%'
    watermarkDiv.style.height = '100%'
    watermarkDiv.style.pointerEvents = 'none'
    watermarkDiv.style.zIndex = '9999'
    watermarkDiv.style.backgroundImage = `url(${watermarkUrl})`
    watermarkDiv.style.backgroundRepeat = 'repeat'
    watermarkDiv.style.backgroundPosition = 'center'

    // 移除旧的水印
    const oldWatermark = el.querySelector('.watermark-layer')
    if (oldWatermark) {
        el.removeChild(oldWatermark)
    }

    watermarkDiv.className = 'watermark-layer'
    el.style.position = 'relative'
    el.appendChild(watermarkDiv)

    // 监听DOM变化，防止水印被删除
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
                const removed = Array.from(mutation.removedNodes)
                if (removed.includes(watermarkDiv)) {
                    el.appendChild(watermarkDiv)
                }
            }
        })
    })

    observer.observe(el, {
        childList: true,
        subtree: true
    })

    // 保存observer以便解绑
    el._watermarkObserver = observer
}

function removeWatermark(el) {
    const watermark = el.querySelector('.watermark-layer')
    if (watermark) {
        el.removeChild(watermark)
    }
    if (el._watermarkObserver) {
        el._watermarkObserver.disconnect()
        delete el._watermarkObserver
    }
}

export default {
    bind(el, binding) {
        addWatermark(el, binding)
    },
    update(el, binding) {
        if (binding.value !== binding.oldValue) {
            removeWatermark(el)
            addWatermark(el, binding)
        }
    },
    unbind(el) {
        removeWatermark(el)
    }
}